import React, { useState, useEffect, useRef } from "react";
import { useForm, Controller } from "react-hook-form";
import TableWrapper from "../../../../core/BaseComponents/TableWrapper/TableWrapper";
import dayjs from "dayjs";
import { Tooltip, CircularProgress, Autocomplete, TextField, FormControlLabel, Radio, RadioGroup } from "@mui/material";
import { MdModeEditOutline } from "react-icons/md";
import { callAPI } from "../../../../../axios";
import DeleteIcon from "@mui/icons-material/Delete";
import BasicModal from "../../../../core/BaseComponents/Modal";
import { ScrollToTop, getChainIdLS, isValidRole } from "../../../../../utils/utils";
import { faImages } from '@fortawesome/free-solid-svg-icons';
import { FileUploader } from "react-drag-drop-files";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import DeleteBackgroundImage from "./DeleteCustomizeWelcomeScreen";
import PreviewBgImage from "./PreviewCustomizeWelcomeScreen ";
import WelcomeLetterPreview from "../../../DefaultWelcomeScreen/WelcomeLetterPreview";
import WelcomeLetterOptionalFields from "../../../DefaultWelcomeScreen/WelcomeLetterOptionalFields";
import { useSelector } from "react-redux";
import { FaArrowsRotate } from "react-icons/fa6";

import EditorConvertToHTML from "./EditorConvertToHTML";
import draftToHtml from 'draftjs-to-html';
import { EditorState, convertToRaw, ContentState } from 'draft-js';
import htmlToDraft from 'html-to-draftjs';
import ImageResolutionTooltip from "../../../ConfigurationNewHotel/ImageResolutionTooltip";
import {
  WELCOME_LETTER_BODY_MIN_LENGTH,
  buildWelcomeLetterHtml,
  buildWelcomeLetterPreviewContent,
  getWelcomeLetterBodyMaxLength,
  getWelcomeMediaPresenceFlags,
  parseWelcomeLetterHtml,
  getAddressTextForPreview,
  prepareAddressTextForSubmit,
  resolveWelcomeLetterAssets,
  validateWelcomeLetterOptionalImageSize,
  validateWelcomeLetterTextLength,
} from "../../../DefaultWelcomeScreen/welcomeLetterHtmlUtils";

const IMAGE_OPTION = "image";
const VIDEO_OPTION = "video";
const DEFAULT_OPTION = "";

function DefaultWelcomeScreen() {
  const [editorState, setEditorState] = useState(EditorState.createEmpty());
  const [welcomeScreenList, setWelcomeScreenList] = useState({});
  const [confirmDeleteWelcomeScreenRow, setConfirmDeleteWelcomeScreenRow] = useState("");
  const [confirmValidate, setConfirmValidate] = useState(false);
  const [deleteWelcomeScreenPopUp, setDeleteWelcomeScreenPopUp] = useState(false);
  const [editWelcomeScreen, setEditWelcomeScreen] = useState(false);
  const [editWelcomeScreenRowUpdate, setEditWelcomeScreenRowUpdate] = useState(false);
  const [createWelcomeScreenSuccessMsg, setCreateWelcomeScreenSuccessMsg] = useState('');
  const [editWelcomeScreenSid, setEditWelcomeScreenSid] = useState("");
  const [loader, setLoader] = useState(false);
  const [imageFileError, setImageFileError] = useState("");
  const [videoFileError, setVideoFileError] = useState("");
  const [files, setFiles] = useState('');
  const [fileUrl, setFileUrl] = useState('');
  const [videoFiles, setVideoFiles] = useState('');
  const [videoFileUrl, setVideoFileUrl] = useState('');
  const [showPreviewPopUp, setShowPreviewPopUp] = useState('');
  const [htmlDraftError, setHtmlDraftError] = useState('');
  const [htmlLength, setHtmlLength] = useState(0)
  const [hotelLogoFile, setHotelLogoFile] = useState('');
  const [hotelLogoPreviewUrl, setHotelLogoPreviewUrl] = useState('');
  const [hotelLogoFileError, setHotelLogoFileError] = useState('');
  const [signatureFile, setSignatureFile] = useState('');
  const [signaturePreviewUrl, setSignaturePreviewUrl] = useState('');
  const [signatureFileError, setSignatureFileError] = useState('');
  const [showWelcomeLetterPreview, setShowWelcomeLetterPreview] = useState(false);
  const [welcomeLetterPreviewHtml, setWelcomeLetterPreviewHtml] = useState('');
  const [mediaCacheBust, setMediaCacheBust] = useState(Date.now());

  const [isEdit, setIsEdit] = useState(false);
  const originalEditFormStateRef = useRef({
    resetValues: null,
    editorState: EditorState.createEmpty(),
    imageUrl: '',
    videoUrl: '',
    hotelLogoUrl: '',
    signatureUrl: '',
  });

  useEffect(() => {
    const plainText = editorState.getCurrentContent().getPlainText();
    setHtmlLength(plainText.length);
  }, [editorState])

  const countOptions = {
    "Always": -1,
    "0": 0,
    "1": 1,
    "2": 2,
    "3": 3,
    "4": 4,
    "5": 5,
    "6": 6,
    "7": 7,
    "8": 8,
    "9": 9,
    "10": 10,
    "11": 11,
    "12": 12,
    "13": 13,
    "14": 14,
    "15": 15,
    "16": 16,
    "17": 17,
    "18": 18,
    "19": 19,
    "20": 20
  }

  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
    control,
    watch,
    setValue,
    setError,
  } = useForm({
    mode: 'onChange',
  });
  const { chainId } = useSelector((state) => state.chainIdReducer);
  let validPermissionClassName = isValidRole("DEFAULT_WELCOME_SCREEN_MODIFY")
    ? ""
    : "btn-disable-permission";

  const defaultWelcomeScreenImage = [
    {
      name: "Default Welcome Screen Image",
      files: 1,
      size: "700 KB",
      height: 1080,
      width: watch("welcomeLetterRequired") ? 900 : 1920,
      resolution: "72 PPI",
      aspect: watch("welcomeLetterRequired") ? "5:6" : "16:09",
      formats: "JPG, JPEG, PNG",
    }
  ]

  const defaultWelcomeScreenVideo = [
    {
      name: "Default Welcome Screen Video",
      files: 1,
      size: "700 KB",
      height: 1080,
      width: 1920,
      // resolution: "NA",
      // aspect: "NA",
      formats: "MP4",
    }
  ]

  const hasWelcomeLetterLogo = Boolean(hotelLogoFile || hotelLogoPreviewUrl);
  const hasWelcomeLetterSignature = Boolean(signatureFile || signaturePreviewUrl);
  const welcomeLetterBodyMaxLength = getWelcomeLetterBodyMaxLength({
    hasLogo: hasWelcomeLetterLogo,
    hasSignature: hasWelcomeLetterSignature,
  });
  const topRightText = watch("topRightText");

  const buildWelcomeLetterPreviewHtml = async () => {
    const rawContentState = editorState.getCurrentContent();
    const plainText = rawContentState.getPlainText();
    const hasWelcomeBody = plainText.trim().length > 0;
    const bodyHtml = hasWelcomeBody ? draftToHtml(convertToRaw(rawContentState)) : "";
    return buildWelcomeLetterPreviewContent({
      bodyHtml,
      topRightText: getAddressTextForPreview(topRightText || ""),
      hotelLogoFile,
      hotelLogoPreviewUrl,
      signatureFile,
      signaturePreviewUrl,
    });
  };

  useEffect(() => {
    if (!showWelcomeLetterPreview) {
      return undefined;
    }

    let cancelled = false;
    buildWelcomeLetterPreviewHtml().then((htmlContent) => {
      if (!cancelled) {
        setWelcomeLetterPreviewHtml(htmlContent);
      }
    });

    return () => {
      cancelled = true;
    };
  }, [
    showWelcomeLetterPreview,
    topRightText,
    editorState,
    hotelLogoFile,
    hotelLogoPreviewUrl,
    signatureFile,
    signaturePreviewUrl,
  ]);

  useEffect(() => {
    if (!watch("welcomeLetterRequired")) {
      return;
    }
    const plainText = editorState.getCurrentContent().getPlainText();
    if (!plainText.trim()) {
      return;
    }
    const bodyLengthError = validateWelcomeLetterTextLength(plainText, {
      hasLogo: hasWelcomeLetterLogo,
      hasSignature: hasWelcomeLetterSignature,
    });
    setHtmlDraftError(bodyLengthError);
  }, [hasWelcomeLetterLogo, hasWelcomeLetterSignature, welcomeLetterBodyMaxLength]);

  const clearWelcomeLetterFields = () => {
    setValue("topRightText", "");
    setHotelLogoFile('');
    setHotelLogoPreviewUrl('');
    setHotelLogoFileError('');
    setSignatureFile('');
    setSignaturePreviewUrl('');
    setSignatureFileError('');
    setEditorState(EditorState.createEmpty());
    setHtmlDraftError('');
    setShowWelcomeLetterPreview(false);
    setWelcomeLetterPreviewHtml('');
  };

  const handleWelcomeLetterPreview = async () => {
    const rawContentState = editorState.getCurrentContent();
    const plainText = rawContentState.getPlainText();
    const hasWelcomeBody = plainText.trim().length > 0;
    const hasLogo = Boolean(hotelLogoFile || hotelLogoPreviewUrl);
    const hasAddress = Boolean((watch("topRightText") || "").trim());
    const hasSignature = Boolean(signatureFile || signaturePreviewUrl);

    if (!hasWelcomeBody && !hasLogo && !hasAddress && !hasSignature) {
      setHtmlDraftError('Add welcome text or optional fields to preview');
      return;
    }

    const htmlContent = await buildWelcomeLetterPreviewHtml();

    setHtmlDraftError('');
    setWelcomeLetterPreviewHtml(htmlContent);
    setShowWelcomeLetterPreview(true);
  };

  const onSubmit = async (data) => {
    const rawContentState = editorState.getCurrentContent();
    const plainText = rawContentState.getPlainText();
    if (!plainText.trim() && watch("welcomeLetterRequired")) {
      setHtmlDraftError('This field is mandatory');
      return;
    }
    if (fileUrl === '' && (watch("imageVideoSelection") === DEFAULT_OPTION || watch("imageVideoSelection") === IMAGE_OPTION)) {
      setImageFileError('Upload image required');
      return;
    } else if (videoFileUrl === "" && (watch("imageVideoSelection") === DEFAULT_OPTION || watch("imageVideoSelection") === VIDEO_OPTION)) {
      setVideoFileError('Upload video required')
      return;
    }
    if (imageFileError !== "" || videoFileError !== '' || hotelLogoFileError || signatureFileError) {
      return;
    }

    const bodyHtml = draftToHtml(convertToRaw(rawContentState));
    if (watch("welcomeLetterRequired")) {
      const bodyLengthError = validateWelcomeLetterTextLength(plainText, {
        hasLogo: hasWelcomeLetterLogo,
        hasSignature: hasWelcomeLetterSignature,
      });
      if (bodyLengthError) {
        setHtmlDraftError(bodyLengthError);
        return;
      }
    }

    if (watch("welcomeLetterRequired") && htmlDraftError !== '') {
      return
    }

    const { normalized: normalizedAddress, error: addressError } = prepareAddressTextForSubmit(data?.topRightText || "");
    if (addressError) {
      setError("topRightText", { type: "manual", message: addressError });
      return;
    }
    if (normalizedAddress !== data?.topRightText) {
      setValue("topRightText", normalizedAddress);
    }

    let htmlContent = "";
    if (watch("welcomeLetterRequired")) {
      const { logoSrc, signatureSrc } = await resolveWelcomeLetterAssets({
        hotelLogoFile,
        hotelLogoPreviewUrl,
        signatureFile,
        signaturePreviewUrl,
      });

      htmlContent = buildWelcomeLetterHtml({
        logoSrc,
        topRightText: normalizedAddress,
        bodyHtml,
        signatureSrc,
      });
    }

    const payload = {
      welcomeLetterBootCounter: countOptions[data?.rebootCounterImage],
      brandVideoBootCounter: countOptions[data?.rebootCountervideo],
      welcomeLetterStandByCounter: countOptions[data?.standbyCounterImage],
      brandVideoStandByCounter: countOptions[data?.standbyCounterVideo],
      videoLoopCount: countOptions[data?.brandVideoLoopCount],
      htmlContent: watch("welcomeLetterRequired") ? htmlContent : ""
    }
    const selection = watch("imageVideoSelection");
    const isImage = selection === IMAGE_OPTION || selection === DEFAULT_OPTION;
    const isVideo = selection === VIDEO_OPTION || selection === DEFAULT_OPTION;
    const { imagePresent, videoPresent } = getWelcomeMediaPresenceFlags({
      imageVideoSelection: selection,
      imageFile: files,
      imagePreviewUrl: fileUrl,
      videoFile: videoFiles,
      videoPreviewUrl: videoFileUrl,
    });

    const formData = new FormData();
    formData.append('defaultImage', isImage ? files : null);
    formData.append('defaultVideo', isVideo ? videoFiles : null);
    formData.append('imagePresent', imagePresent);
    formData.append('videoPresent', videoPresent);
    formData.append('defaultWelcomeMsgRequest', new Blob([JSON.stringify(payload)], { type: 'application/json' }))
    let method = "POST";
    let url = `/welcome-letter-config`;
    if (editWelcomeScreenRowUpdate) {
      method = "PUT"
      url = `/welcome-letter-config?sid=${editWelcomeScreenSid?.id}`;
    }
    setLoader(true);
    callAPI(url, method, formData, { chainId: getChainIdLS() })
      .then(function (response) {
        setLoader(false);
        reset({
          rebootCounterImage: "Always",
          rebootCountervideo: "Always",
          standbyCounterImage: "Always",
          standbyCounterVideo: "Always",
          brandVideoLoopCount: 3,
          welcomeLetterRequired: false,
          topRightText: "",
        });
        setFileUrl('');
        setFiles('');
        setVideoFileUrl('');
        setVideoFiles('');
        clearWelcomeLetterFields();
        setCreateWelcomeScreenSuccessMsg(response?.message);
        setEditWelcomeScreenSid('');
      })
      .catch(function (error) {
        setLoader(false);
        console.warn(error.response?.data?.errorMessage);
      });
  };

  const isWelcomeScreenDeletedRef = useRef({
    isWelcomeScreenDeletedModalData: null,
    userConformationModalData: null,
  });


  const deleteWelcomeScreenConfigPopUpHandler = (row) => {
    setDeleteWelcomeScreenPopUp(true);
    const newModalRefData = {
      isWelcomeScreenDeletedModalData: {
        row
      },
      userConformationModalData: null,
    };
    isWelcomeScreenDeletedRef.current = newModalRefData;
  }

  const deleteWelcomeScreenHandler = () => {
    setConfirmValidate(true);
    if (confirmDeleteWelcomeScreenRow === "") {
      return
    }

    if (confirmDeleteWelcomeScreenRow === `Delete`) {
      setConfirmValidate(false)
      const { row } = isWelcomeScreenDeletedRef.current?.isWelcomeScreenDeletedModalData;
      callAPI(`/welcome-letter-config?sid=${row?.id}`, "DELETE")
        .then((response) => {
          let successMessage = response.message
          const newModalRefData = {
            isWelcomeScreenDeletedModalData: null,
            userConformationModalData: {
              successMessage
            },
          };
          isWelcomeScreenDeletedRef.current = newModalRefData;
          defaultWelcomeScreenListApi();
          setEditorState(EditorState.createEmpty());
          cancelWelcomeScreenHandler()
        })
        .catch((error) => {
          console.warn(error)
        });
    }
    // reset({
    //   htmlContent: '',
    // });
    setFileUrl('');
    setFiles('');
    setVideoFileUrl('');
    setVideoFiles('');
  }


  const renderActionIcon = (row) => {
    return (
      isValidRole("DEFAULT_WELCOME_SCREEN_MODIFY") ? <>
        {!row?.published ? <>
          <Tooltip title="Edit" arrow>
            <MdModeEditOutline
              className="edit-icon-enable"
              onClick={() => { setEditWelcomeScreen(true); setEditWelcomeScreenSid(row); setIsEdit(true) }}
            />
          </Tooltip>
          <Tooltip title="Delete" className="cursor-pointer" arrow>
            <DeleteIcon
              className="delete-icon-enable"
              onClick={() => {
                deleteWelcomeScreenConfigPopUpHandler(row);
              }}
            />
          </Tooltip>
        </> : <>
          <Tooltip title="Check-Out to perform actions">
            <span>
              <MdModeEditOutline className="edit-icon-disable" arrow />
            </span>
          </Tooltip>
          <Tooltip title="Check-Out to perform actions">
            <DeleteIcon className="delete-icon-disable" arrow />
          </Tooltip>
        </>
        }
      </> :
        <>
          <Tooltip title="Don't have permission to edit">
            <span>
              <MdModeEditOutline className="edit-icon-disable" arrow />
            </span>
          </Tooltip>
          <Tooltip title="Don't have permission to delete">
            <DeleteIcon className="delete-icon-disable" arrow />
          </Tooltip>
        </>
    );
  };

  const getCacheBustedMediaUrl = (url, withThumbnailFrame = false) => {
    if (!url) return '';
    const separator = url.includes('?') ? '&' : '?';
    const bustedUrl = `${url}${separator}v=${mediaCacheBust}`;
    return withThumbnailFrame ? `${bustedUrl}#t=0.1` : bustedUrl;
  };

  const renderVideoPreview = (row) => {
    return <div className="screen-saver-video d-flex">
      {row?.defaultVideoUrl ? (
        <video
          key={`${row?.id}-${chainId}-${mediaCacheBust}`}
          width="400"
          controls={false}
          preload="metadata"
          onClick={() => setShowPreviewPopUp(row?.defaultVideoUrl)}
        >
          <source src={getCacheBustedMediaUrl(row?.defaultVideoUrl, true)} type="video/mp4" />
        </video>
      ) : "N.A"}
    </div>
  }

  const columns = [
    { field: "createdDate", headerName: "Created On", flex: 1, row: true, renderCell: (row) => <p className="mb-0">{dayjs(row.createdOn).format("DD MMM YYYY | HH:mm")}</p> },
    { field: 'defaultImageUrl', headerName: 'Image Preview', flex: 1, row: true, renderCell: (row) => (row?.defaultImageUrl ? <img src={row?.defaultImageUrl} alt={row?.id} className="background-config-img" onClick={() => setShowPreviewPopUp(row?.defaultImageUrl)} /> : "N.A"), disableSortIcon: true, },
    {
      field: 'defaultVideoUrl', headerName: 'Video Preview', flex: 1, row: true, renderCell: renderVideoPreview, disableSortIcon: true,
    },
    // {
    //   field: "actionCell",
    //   row: true,
    //   headerName: "Actions",
    //   flex: 0.5,
    //   renderCell: renderActionIcon,
    //   sortDirection: false,
    //   disableSortIcon: true,
    // },
  ];


  const resetWelcomeScreenForm = () => {
    setFileUrl('');
    setFiles('');
    setVideoFileUrl('');
    setVideoFiles('');
    setEditWelcomeScreenRowUpdate(false);
    setEditWelcomeScreenSid('');
    setEditWelcomeScreen(false);
    setEditorState(EditorState.createEmpty());
    setImageFileError('');
    setVideoFileError('');
    setHtmlDraftError('');
    setHotelLogoFile('');
    setHotelLogoPreviewUrl('');
    setHotelLogoFileError('');
    setSignatureFile('');
    setSignaturePreviewUrl('');
    setSignatureFileError('');
    setShowWelcomeLetterPreview(false);
    setWelcomeLetterPreviewHtml('');
    originalEditFormStateRef.current = {
      resetValues: null,
      editorState: EditorState.createEmpty(),
      imageUrl: '',
      videoUrl: '',
      hotelLogoUrl: '',
      signatureUrl: '',
    };
    reset({
      rebootCounterImage: "Always",
      rebootCountervideo: "Always",
      standbyCounterImage: "Always",
      standbyCounterVideo: "Always",
      brandVideoLoopCount: 3,
      welcomeLetterRequired: false,
      imageVideoSelection: DEFAULT_OPTION,
      topRightText: "",
    });
    setIsEdit(false);
  };

  const defaultWelcomeScreenListApi = () => {
    // const apiPath = `/customize-screen-search?pageNo=${selectedPage}&recordsPerPage=${recordsPerPage}`, "POST", {}, { chainId: getChainIdLS() }`;
    callAPI(`/welcome-letter-config`, "GET", {}, { chainId: getChainIdLS() })
      .then((response) => {
        setWelcomeScreenList(response);
        setMediaCacheBust(Date.now());
      })
      .catch((err) => console.warn(err.message));
    setIsEdit(false)
  };

  useEffect(() => {
    setWelcomeScreenList({});
    setMediaCacheBust(Date.now());
    defaultWelcomeScreenListApi();
    resetWelcomeScreenForm();
  }, [chainId]);


  const popupCloseHandler = () => {
    setDeleteWelcomeScreenPopUp(false);
  };


  useEffect(() => {
    if (editWelcomeScreen) {
      getWelcomeScreenListSidHandler();
      setEditWelcomeScreen(false);
    }
    ScrollToTop();
    setImageFileError('');
    setVideoFileError('');
  }, [editWelcomeScreen]);

  const getWelcomeScreenListSidHandler = () => {
    callAPI(`/welcome-letter-config/${editWelcomeScreenSid?.id}`, "GET")
      .then(function (response) {
        const parsed = parseWelcomeLetterHtml(response?.htmlContent || "");
        const radioSelection = !!response?.defaultImageUrl && !!response?.defaultVideoUrl ? DEFAULT_OPTION :
          !!response?.defaultImageUrl ? IMAGE_OPTION : VIDEO_OPTION;
        const payload = {
          welcomeLetterRequired: !!response?.htmlContent,
          rebootCounterImage: countOptions[response?.welcomeLetterBootCounter],
          rebootCountervideo: countOptions[response?.brandvideoBootCounter],
          standbyCounterImage: countOptions[response?.welcomeLetterStandByCounter],
          standbyCounterVideo: countOptions[response?.brandVideoStandByCounter],
          brandVideoLoopCount: countOptions[response?.videoLoopCount],
          imageVideoSelection: radioSelection,
          topRightText: parsed.topRightTextPlain,
        };
        const contentBlock = htmlToDraft(parsed.bodyHtml || '');
        if (contentBlock) {
          const contentState = ContentState.createFromBlockArray(contentBlock.contentBlocks);
          const newEditorState = EditorState.createWithContent(contentState);
          setEditorState(newEditorState);
        } else {
          setEditorState(EditorState.createEmpty());
        }
        setHotelLogoPreviewUrl(parsed.logoSrc || '');
        setSignaturePreviewUrl(parsed.signatureSrc || '');
        setHotelLogoFile('');
        setSignatureFile('');
        setHotelLogoFileError('');
        setSignatureFileError('');
        setFileUrl(response?.defaultImageUrl);
        setVideoFileUrl(response?.defaultVideoUrl);
        originalEditFormStateRef.current = {
          resetValues: {
            welcomeLetterRequired: !!response?.htmlContent,
            rebootCounterImage: countOptions[response?.welcomeLetterBootCounter],
            rebootCountervideo: countOptions[response?.brandvideoBootCounter],
            standbyCounterImage: countOptions[response?.welcomeLetterStandByCounter],
            standbyCounterVideo: countOptions[response?.brandVideoStandByCounter],
            brandVideoLoopCount: countOptions[response?.videoLoopCount],
            imageVideoSelection: radioSelection,
            topRightText: parsed.topRightTextPlain,
          },
          editorState: contentBlock
            ? EditorState.createWithContent(ContentState.createFromBlockArray(contentBlock.contentBlocks))
            : EditorState.createEmpty(),
          imageUrl: response?.defaultImageUrl || '',
          videoUrl: response?.defaultVideoUrl || '',
          hotelLogoUrl: parsed.logoSrc || '',
          signatureUrl: parsed.signatureSrc || '',
        };
        reset(payload);
        setEditWelcomeScreenRowUpdate(true);
        setHtmlDraftError('');
      })
      .catch(function (error) {
        console.warn(error.response?.data?.errorMessage);
      });
  }

  const resetLayoutHandler = () => {
    const originalState = originalEditFormStateRef.current;
    if (originalState?.resetValues) {
      reset(originalState.resetValues);
      setFileUrl(originalState.imageUrl);
      setVideoFileUrl(originalState.videoUrl);
      setEditorState(originalState.editorState);
      setHotelLogoPreviewUrl(originalState.hotelLogoUrl || '');
      setSignaturePreviewUrl(originalState.signatureUrl || '');
      setHotelLogoFile('');
      setSignatureFile('');
      setHotelLogoFileError('');
      setSignatureFileError('');
      setShowWelcomeLetterPreview(false);
      setWelcomeLetterPreviewHtml('');
    } else {
      reset({
        rebootCounterImage: "Always",
        rebootCountervideo: "Always",
        standbyCounterImage: "Always",
        standbyCounterVideo: "Always",
        brandVideoLoopCount: 3,
        welcomeLetterRequired: false,
        imageVideoSelection: DEFAULT_OPTION,
        topRightText: "",
      });
      setFileUrl('');
      setVideoFileUrl('');
      setEditorState(EditorState.createEmpty());
      clearWelcomeLetterFields();
    }
    setFiles('');
    setVideoFiles('');
    setImageFileError('');
    setVideoFileError('');
    setHtmlDraftError('');
  }

  const cancelWelcomeScreenHandler = () => {
    resetWelcomeScreenForm();
  }

  const imageUploadOrDragFileHandler = (fileList) => {
    let bytes = (fileList.size / 1024).toFixed(2);
    setFileUrl(URL.createObjectURL(fileList));
    if (bytes > 700) {
      setImageFileError('Upload file should be less than 700KB');
      return;
    }
    setFiles(fileList);
    setImageFileError('');
  }
  const deleteLogoHandler = () => {
    setFiles('');
    setFileUrl('');
    setImageFileError('');
  };

  const hotelLogoUploadHandler = (fileList) => {
    const fileError = validateWelcomeLetterOptionalImageSize(fileList, "Hotel logo");
    if (fileError) {
      setHotelLogoFileError(fileError);
      return;
    }
    setHotelLogoPreviewUrl(URL.createObjectURL(fileList));
    setHotelLogoFile(fileList);
    setHotelLogoFileError('');
  };

  const deleteHotelLogoHandler = () => {
    setHotelLogoFile('');
    setHotelLogoPreviewUrl('');
    setHotelLogoFileError('');
  };

  const signatureUploadHandler = (fileList) => {
    const fileError = validateWelcomeLetterOptionalImageSize(fileList, "Signature");
    if (fileError) {
      setSignatureFileError(fileError);
      return;
    }
    setSignaturePreviewUrl(URL.createObjectURL(fileList));
    setSignatureFile(fileList);
    setSignatureFileError('');
  };

  const deleteSignatureHandler = () => {
    setSignatureFile('');
    setSignaturePreviewUrl('');
    setSignatureFileError('');
  };

  const videoUploadOrDragFileHandler = (fileList) => {
    // let bytes = (fileList.size / 1024).toFixed(2);
    setVideoFileUrl(URL.createObjectURL(fileList));
    // if (bytes > 700) {
    //   setImageFileError('Upload file should be less than 700KB');
    //   return;
    // }
    setVideoFiles(fileList);
    setVideoFileError('');
  }

  return (
    <div className='row config-hotel config-management-form'>
      <div className='col-12 left-column'>
        {loader && <div className="circular-progress"><CircularProgress /></div>}
        <form autoComplete="off" className={`hotel-list-form ${isEdit ? "" : Object.keys(welcomeScreenList).length > 1 ? "page-mask" : ""} `}>
          {/* <form autoComplete="off" className={`hotel-list-form `}> */}
          {Object.keys(welcomeScreenList).length > 1 && !isEdit && <div className='mask-content default-config'>Only one Welcome configuration can be created at a time. <br /> Please update existing one if required.</div>}
          <div className="row">
            <div className="left-column-header">
              <p className="Roboto-Bold">{editWelcomeScreenRowUpdate ? 'Edit Default Welcome Screen' : 'Default Welcome Screen'}</p>
            </div>
            <div className="row">
              <div className="col-6">
                <Controller
                  name="imageVideoSelection"
                  control={control}
                  defaultValue=""
                  render={({ field }) => (
                    <RadioGroup
                      row
                      value={field.value}   // <-- explicitly set value
                      onChange={(event) => {
                        const val = event.target.value;
                        field.onChange(val);
                        if (val === IMAGE_OPTION) {
                          setValue("rebootCountervideo", 0)
                          setValue("standbyCounterVideo", 0)
                          setValue("rebootCounterImage", "Always")
                          setValue("standbyCounterImage", "Always")
                        }
                        else if (val === VIDEO_OPTION) {
                          setValue("rebootCounterImage", 0)
                          setValue("standbyCounterImage", 0)
                          setValue("rebootCountervideo", "Always")
                          setValue("standbyCounterVideo", "Always")
                          setValue("welcomeLetterRequired", false)
                          if (!editWelcomeScreenRowUpdate) {
                            clearWelcomeLetterFields()
                          }
                        }
                        else {
                          setValue("rebootCountervideo", "Always")
                          setValue("standbyCounterVideo", "Always")
                          setValue("rebootCounterImage", "Always")
                          setValue("standbyCounterImage", "Always")
                        }
                      }}
                      className="h-auto main-events mt-0 mb-1"
                    >
                      <FormControlLabel
                        value={DEFAULT_OPTION}
                        control={<Radio />}
                        label="With Video & Image"
                      />
                      <FormControlLabel
                        value={IMAGE_OPTION}
                        control={<Radio />}
                        label="Image Only"
                      />
                      <FormControlLabel
                        value={VIDEO_OPTION}
                        control={<Radio />}
                        label="Video Only"
                      />
                    </RadioGroup>
                  )}
                />
              </div>
              <div className="form-group-hotel col-6">
                <input
                  type="checkbox"
                  id="welcomeLetterRequired"
                  {...register("welcomeLetterRequired", {
                    onChange: (e) => {
                      if (!e.target.checked && !editWelcomeScreenRowUpdate) {
                        clearWelcomeLetterFields();
                      }
                    }
                  })}
                  disabled={watch("imageVideoSelection") === VIDEO_OPTION}
                />
                <label className="ms-2" htmlFor="welcomeLetterRequired">
                  With Welcome Letter Text
                </label>
              </div>
            </div>
            {watch("welcomeLetterRequired") && watch("imageVideoSelection") !== VIDEO_OPTION && <div>
              <div className="d-flex justify-content-between align-items-center welcome-letter-preview-actions">
                <button
                  type="button"
                  className="clear-btn"
                  onClick={handleWelcomeLetterPreview}
                >
                  Preview Welcome Letter
                </button>
                <p className="mb-0">Welcome Text Size (Minimum: {WELCOME_LETTER_BODY_MIN_LENGTH} || Maximum: {welcomeLetterBodyMaxLength}) : {htmlLength}</p>
              </div>
              <EditorConvertToHTML
                setEditorState={setEditorState}
                editorState={editorState}
                setHtmlDraftError={setHtmlDraftError}
                maxLength={welcomeLetterBodyMaxLength}
              />
              {htmlDraftError && <p className="required">{htmlDraftError}</p>}
              <WelcomeLetterOptionalFields
                register={register}
                errors={errors}
                watch={watch}
                setValue={setValue}
                hotelLogoPreviewUrl={hotelLogoPreviewUrl}
                hotelLogoFileError={hotelLogoFileError}
                onHotelLogoUpload={hotelLogoUploadHandler}
                onHotelLogoRemove={deleteHotelLogoHandler}
                signaturePreviewUrl={signaturePreviewUrl}
                signatureFileError={signatureFileError}
                onSignatureUpload={signatureUploadHandler}
                onSignatureRemove={deleteSignatureHandler}
              />
            </div>}
            {(watch("imageVideoSelection") === IMAGE_OPTION || watch("imageVideoSelection") === DEFAULT_OPTION) && <div className={`form-group-hotel ${watch("imageVideoSelection") === IMAGE_OPTION ? "col-12" : "col-6"}`}>
              {!!fileUrl ? <div className="partner-logo">
                <img src={fileUrl} alt={fileUrl} />
                <span onClick={() => deleteLogoHandler()}>X</span>
              </div>
                : <FileUploader
                  name="file"
                  types={["JPG", "PNG", 'JPEG']}
                  handleChange={imageUploadOrDragFileHandler}
                  classes="drag-file file-upload-bg"
                  children={
                    <>
                      <FontAwesomeIcon icon={faImages} className="fa-lg" />
                      <p className="drag-text">
                        Drag and drop image or
                        <span> Browse</span>
                        <br />
                        To upload <span className="Roboto-Bold text-black">Image</span> here.
                        <ImageResolutionTooltip data={defaultWelcomeScreenImage} />
                      </p>
                      {/* <h6> Formats Supported : JPG, JPEG and PNG</h6>
                      <p className="fnt-12px mb-0">Image size should be 800x800</p> */}
                    </>
                  }
                />
              }

              {imageFileError && <p className="required">{imageFileError}</p>}
            </div>}
            {(watch("imageVideoSelection") === VIDEO_OPTION || watch("imageVideoSelection") === DEFAULT_OPTION) && <div className={`form-group-hotel ${watch("imageVideoSelection") === VIDEO_OPTION ? "col-12" : "col-6"}`}>
              {!!videoFileUrl ? <div className="partner-logo">
                <video className="col-12" controls key={videoFileUrl}>
                  <source src={videoFileUrl} type={videoFileUrl?.type} />
                  Your browser does not support the video tag.
                </video>
                <span className="re-upload-icon">
                  <FileUploader
                    name="file"
                    types={["MP4"]}
                    handleChange={videoUploadOrDragFileHandler}
                    classes="re-upload-file"
                    children={<FaArrowsRotate />}
                  />
                </span>
              </div>
                : <FileUploader
                  name="file"
                  types={["MP4"]}
                  handleChange={videoUploadOrDragFileHandler}
                  classes="drag-file file-upload-bg"
                  children={
                    <>
                      <FontAwesomeIcon icon={faImages} className="fa-lg" />
                      <p className="drag-text">
                        Drag and drop video or
                        <span> Browse</span>
                        <br />
                        To upload <span className="Roboto-Bold text-black">Video</span> here.
                        <ImageResolutionTooltip data={defaultWelcomeScreenVideo} />
                      </p>
                      {/* <h6> Formats Supported : MP4</h6> */}
                      <p className="pb-1"></p>
                    </>
                  }
                />
              }
              {videoFileError && <p className="required">{videoFileError}</p>}
            </div>}
            <div className="col form-group-hotel">
              {/* <p className="mb-1">Video Loop count</p> */}
              <div className="floating-select-label">
                <Controller
                  name="rebootCounterImage"
                  defaultValue={"Always"}
                  control={control}
                  rules={{ required: "Welcome Image Reboot Counter is required" }}
                  render={({ field, fieldState: { error } }) => (
                    <Autocomplete
                      {...field}
                      className={`multiselectlist ${field.value !== null && field.value !== undefined ? 'Mui-focused' : ''}`}
                      disablePortal
                      disabled={watch("imageVideoSelection") === VIDEO_OPTION}
                      options={["Always", 0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20]}
                      getOptionLabel={(option) => option.toString()}
                      onChange={(_, newValue) => {
                        field.onChange(newValue);
                      }}
                      value={field.value}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          placeholder=""
                          variant="outlined"
                          label="Welcome Image Reboot Counter"
                          InputLabelProps={{
                            shrink: false,
                          }}
                        />
                      )}
                    />
                  )}
                />
              </div>
              {errors.rebootCounterImage && (
                <small className="required">{errors.rebootCounterImage.message}</small>
              )}
            </div>
            <div className="col form-group-hotel">
              {/* <p className="mb-1">Video Loop count</p> */}
              <div className="floating-select-label">
                <Controller
                  name="rebootCountervideo"
                  defaultValue={"Always"}
                  control={control}
                  rules={{ required: "Brand Video Reboot Counter is required" }}
                  render={({ field, fieldState: { error } }) => (
                    <Autocomplete
                      {...field}
                      className={`multiselectlist ${field.value !== null && field.value !== undefined ? 'Mui-focused' : ''}`}
                      disablePortal
                      disabled={watch("imageVideoSelection") === IMAGE_OPTION}
                      options={["Always", 0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20]}
                      getOptionLabel={(option) => option.toString()}
                      onChange={(_, newValue) => {
                        field.onChange(newValue);
                      }}
                      value={field.value}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          placeholder=""
                          variant="outlined"
                          label="Brand Video Reboot Counter"
                          InputLabelProps={{
                            shrink: false,
                          }}
                        />
                      )}
                    />
                  )}
                />
              </div>
              {errors.rebootCountervideo && (
                <small className="required">{errors.rebootCountervideo.message}</small>
              )}
            </div>
            <div className="col form-group-hotel">
              {/* <p className="mb-1">Video Loop count</p> */}
              <div className="floating-select-label">
                <Controller
                  name="standbyCounterImage"
                  defaultValue={"Always"}
                  control={control}
                  rules={{ required: "Welcome Image Standby Counter is required" }}
                  render={({ field, fieldState: { error } }) => (
                    <Autocomplete
                      {...field}
                      className={`multiselectlist ${field.value !== null && field.value !== undefined ? 'Mui-focused' : ''}`}
                      disablePortal
                      disabled={watch("imageVideoSelection") === VIDEO_OPTION}
                      options={["Always", 0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20]}
                      getOptionLabel={(option) => option.toString()}
                      onChange={(_, newValue) => {
                        field.onChange(newValue);
                      }}
                      value={field.value}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          placeholder=""
                          variant="outlined"
                          label="Welcome Image Standby Counter"
                          InputLabelProps={{
                            shrink: false,
                          }}
                        />
                      )}
                    />
                  )}
                />
              </div>
              {errors.standbyCounterImage && (
                <small className="required">{errors.standbyCounterImage.message}</small>
              )}
            </div>
            <div className="col form-group-hotel">
              {/* <p className="mb-1">Video Loop count</p> */}
              <div className="floating-select-label">
                <Controller
                  name="standbyCounterVideo"
                  defaultValue={"Always"}
                  control={control}
                  rules={{ required: "Brand Video Standby Counter is required" }}
                  render={({ field, fieldState: { error } }) => (
                    <Autocomplete
                      {...field}
                      className={`multiselectlist ${field.value !== null && field.value !== undefined ? 'Mui-focused' : ''}`}
                      disablePortal
                      disabled={watch("imageVideoSelection") === IMAGE_OPTION}
                      options={["Always", 0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20]}
                      getOptionLabel={(option) => option.toString()}
                      onChange={(_, newValue) => {
                        field.onChange(newValue);
                      }}
                      value={field.value}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          placeholder=""
                          variant="outlined"
                          label="Brand Video Standby Counter"
                          InputLabelProps={{
                            shrink: false,
                          }}
                        />
                      )}
                    />
                  )}
                />
              </div>
              {errors.standbyCounterVideo && (
                <small className="required">{errors.standbyCounterVideo.message}</small>
              )}
            </div>
            <div className="col-2 status-switch form-group-hotel">
              {/* <p className="mb-1">Video Loop count</p> */}
              <div className="floating-select-label">
                <Controller
                  name="brandVideoLoopCount"
                  defaultValue={3}
                  control={control}
                  rules={{ required: "Brand Video Loop Counter is required" }}
                  render={({ field, fieldState: { error } }) => (
                    <Autocomplete
                      {...field}
                      className={`multiselectlist ${field.value !== null && field.value !== undefined ? 'Mui-focused' : ''}`}
                      disablePortal
                      disabled={watch("imageVideoSelection") === IMAGE_OPTION}
                      options={[3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20]}
                      getOptionLabel={(option) => option.toString()}
                      onChange={(_, newValue) => {
                        field.onChange(newValue);
                      }}
                      value={field.value}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          placeholder=""
                          variant="outlined"
                          label="Brand Video Loop Counter"
                          InputLabelProps={{
                            shrink: false,
                          }}
                        />
                      )}
                    />
                  )}
                />
              </div>
              {errors.brandVideoLoopCount && (
                <small className="required">{errors.brandVideoLoopCount.message}</small>
              )}
            </div>
            <div className="col-12 text-end form-group-hotel">
              <button type="button" className="clear-btn me-2" onClick={cancelWelcomeScreenHandler}>{editWelcomeScreenRowUpdate ? "Cancel" : "Clear All"}</button>
              {editWelcomeScreenRowUpdate && <>
                <button type="button" className="clear-btn me-2" onClick={resetLayoutHandler}>Reset</button>
              </>}
              {/* {!editWelcomeScreenRowUpdate && <button type="button" onClick={handleSubmit(onSave)} className={`disable-btn me-2 ${validPermissionClassName}`}>Save</button>} */}
              <button type="button" onClick={handleSubmit(onSubmit)} className={`create-btn ${validPermissionClassName}`}>{editWelcomeScreenRowUpdate ? "Update" : "Submit"}</button>
            </div>
          </div>

        </form>
        <div className="hotel-list">
          <p><b>Default Welcome Screen Config</b></p>

          <TableWrapper
            data={Object.keys(welcomeScreenList).length > 1 ? [welcomeScreenList] : []}
            columns={columns}
            noPagination={true}
            module="customize-welcome-screen"
          />

        </div>
      </div>
      {deleteWelcomeScreenPopUp && <DeleteBackgroundImage
        deleteWelcomeScreenPopUp={deleteWelcomeScreenPopUp}
        isWelcomeScreenDeletedRef={isWelcomeScreenDeletedRef}
        popupCloseHandler={popupCloseHandler}
        deleteWelcomeScreenHandler={deleteWelcomeScreenHandler}
        setConfirmDeleteWelcomeScreenRow={setConfirmDeleteWelcomeScreenRow}
        confirmDeleteWelcomeScreenRow={confirmDeleteWelcomeScreenRow}
        confirmValidate={confirmValidate}
      />}
      <BasicModal
        popupOpen={createWelcomeScreenSuccessMsg !== ""}
        logo={"/Images/approve-qc.png"}
        bodyMessage={<p className="mt-2">{createWelcomeScreenSuccessMsg}</p>}
        footer={
          {
            secondaryButton: {
              buttonName: "OK",
              action: () => { setCreateWelcomeScreenSuccessMsg(''); setEditWelcomeScreenRowUpdate(false); defaultWelcomeScreenListApi(); },
              buttonPrimaryCustomCss: 'cancel-btn_new'
            }
          }
        }
      />
      {showPreviewPopUp !== "" && <PreviewBgImage
        showPreviewPopUp={showPreviewPopUp}
        setShowPreviewPopUp={setShowPreviewPopUp}
      />}
      <WelcomeLetterPreview
        isOpen={showWelcomeLetterPreview}
        onClose={() => setShowWelcomeLetterPreview(false)}
        htmlContent={welcomeLetterPreviewHtml}
      />

    </div>
  )
}

export default DefaultWelcomeScreen;